export const messages = {
    en: {
        welcomeMsg: 'Welcome to Your Vue.js App',
        global: {
            response: {
                error: {
                    400: 'Unauthorized operation',
                    401: 'Please fill all data'
                }
            }
        },
        header: {
            logout: 'Sign out',
            signed_as: 'Signed in as',
            stats: {
                events: 'Events',
                snapshots: 'Snapshots',
                videos: 'Videos',
                media: 'Media'
            },
            menu: {
                dashboard: 'Dashboard',
                settings: 'Settings',
                reports: 'Reports'
            }
        },
        dashboard: {
            fleetOverview: {
                header: 'Fleet overview',
                driving: 'Driving',
                offline: 'Offline',
                sleep: 'Sleep'
            },
            fleetList: {
                header: 'Fleets List',
                searchInput: 'Search fleet name or registration number or device number',
                carBox: {
                    journeyReportLink: 'Journey report',
                    journeyTodaysLink: 'Today’s journeys'
                }
            }
        },
        listFleet: {
            title: 'Fleets Groups',
            forms: {
                search: {
                    label: 'Search'
                }
            },
            table: {
                headers: {
                    name: 'Name',
                    parentGroup: 'Parent Group',
                    organizationName: 'Organization Name',
                    allocatedDevices: 'Allocated Devices',
                    unallocatedDevices: 'Unallocated Devices',
                    totalDevices: 'Total Devices',
                    edit: 'Edit',
                    delete: 'Delete'
                }
            },
            buttons: {
                delete: {
                    text: 'Delete',
                    smallText: '(Selected fleets)'
                },
                create: {
                    text: 'Add Fleet Group'
                }
            },
            modal: {
                deleteConfirmation: {
                    title: 'Confirmation',
                    text1: 'Are you sure you want to delete',
                    text2: 'fleets',
                    cancelButton: 'Disagree',
                    okButton: 'Agree'
                }
            },
            messages: {
                delete: {
                    success: {
                        text1: 'Fleet',
                        text2: 'successfully deleted.'
                    },
                    error: {
                        text: 'You muse select at least one fleet to delete.'
                    }
                }
            }
        },
        createFleet: {
            title: 'Add Fleet Group',
            info: 'Add info about New Fleet Group',
            successMassage: 'Fleet successfully created.'
        },
        editFleet: {
            title: 'Edit Fleet Group',
            info: 'Edit info about Fleet Group',
            successMassage: 'Fleet successfully updated.'
        },
        formFleet: {
            forms: {
                name: {
                    name: 'Name',
                    label: 'Insert name',
                    rules: {
                        required: 'Name is required',
                        length: 'Name must be at least 4 and less than 255 characters'
                    }
                },
                parentFleet: {
                    name: 'Parent fleet group',
                    label: 'Select a fleet group',
                    placeholder: 'Start typing to search',
                    rules: {
                        required: 'Parent fleet group is required'
                    }
                }
            },
            buttons: {
                goBack: 'Go Back',
                save: 'Save'
            }
        },
        createDevice: {
            title: 'Add vehicle device'
        },
        settingsDialog: {
            eventForm: {
                emailNotifications: 'E-mail notification',
                uiNotifications: 'UI notification',
                newJourneyMinuteInterval: 'Journey interval'
            }
        },
        createOrganization: {
            title: 'Create new organization'
        },
        eventTypes: {
            Unknown: 'Unknown',
            Speed: 'Speed',
            Brake: 'Brake',
            Accelerate: 'Accelerate',
            Shock: 'Shock',
            Turn: 'Turn',
            Button: 'Button',
            Fatigue: 'Fatigue',
            Smoking: 'Smoking',
            Distraction: 'Distraction',
            NoDriver: 'NoDriver',
            MobilePhoneWarning: 'Mobile Phone Warning',
            LeftHandIndicator: 'Left Hand Indicator',
            RightHandIndicator: 'Right Hand Indicator',
            VehicleReversing: 'Vehicle Reversing',
            IgnitionOn: 'Ignition On',
            IgnitionOff: 'Ignition Off',
            LaneDeparture: 'Lane Departure',
            ForwardCollisionWarning: 'Forward Collision Warning',
            FollowingDistanceWarning: 'Following Distance Warning',
            HumanDetection: 'Human Detection',
            Diagnostics: 'Diagnostics',
            System: 'System',
            GpsFault: 'Gps Fault',
            VideoLoss: 'Video Loss',
            StorageAbnormal: 'Storage Abnormal',
            CameraCovered: 'Camera Covered',
            VideoRequest: 'Video Request'
        }
    }
}
